// @ts-strict
import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { LMContextService, LMRouteComponentService, LMUrlInfoBuilderService, LMUrlUtilService } from './services';
import { AppConstants, LMContextUtilService, LMGlobalUtilService } from './utils';
import { LMBaseComponent } from '@base/lm-base.component';
import { LMHttpIntercepterService } from '@services/lm-http-intercepter.service';
import { LMThemeService } from '@banner/lm-theme.service';
export const getApiPath = (isDevMode: boolean, devApiPath: string): string =>
  isDevMode
    ? devApiPath
    : `${window.location.protocol}//${window.location.host}${window.location.pathname}api`;
/**
 * HttpErrorInterceptor intercepts HTTP error response and show a message to the users
 */

@Injectable()
export class UserWebRequestHttpInterceptor implements HttpInterceptor {

  private componentInfo?: LMComponentInfo;

  constructor(
    private httpClient: HttpClient,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public lmRouteComponentService: LMRouteComponentService,
    public lmHttpIntercepterService: LMHttpIntercepterService,
    private lmGlobalUtilService: LMGlobalUtilService,
    private lmUrlInfoBuilderService: LMUrlInfoBuilderService,
    private lmContextService: LMContextService,
    private lmUrlUtilService: LMUrlUtilService,
    private lmThemeService: LMThemeService
  ) {
  }

  // tslint:disable-next-line
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.setMingleActivateCookie(req);
    const context = this.lmContextService.getContext();
    // dont intercept the calls unless the Sumo flag is set. Using that for now. It can split later if that becomes required
    if (context && !this.lmContextService.isSumoEnabled()) {
      return next.handle(req);
    }

    let webReportHeaders = req.headers;
    const comp = this.lmRouteComponentService.getRouteComponent() as LMBaseComponent;

    if (comp) {
      this.componentInfo = comp.getComponentInfo();
    }
    const hasCompInfo = (comp && comp !== null && this.componentInfo) ? true : false;
    const hasCompConfigInfo = (comp && comp !== null && this.componentInfo && this.componentInfo.configInfo) ? true : false;
    const compConfigInfo = hasCompConfigInfo ? this.componentInfo?.configInfo : undefined;

    // now ass info to the component info have to
    // .make sure the  url has a busClassName of the builder service will blow
    let processUrl: string = req.url;
    let tenantUrl = '';
    const splitUrl = processUrl.split('//');

    let tenant!: string;
    let envType!: string;
    if (splitUrl.length >= 2) {
      processUrl = splitUrl[ 1 ].substring((splitUrl[ 1 ].indexOf('/') + 1));
      tenantUrl = splitUrl[ 1 ].split('/')[ 0 ].split(':')[ 0 ];
      const tenantPieces = tenantUrl.split('.')[ 0 ].split('-');
      if (tenantPieces.length >= 3) {
        tenant = tenantPieces[ 1 ];
        envType = tenantPieces[ 2 ];
      } else {
        tenant = processUrl.split('/')[ 0 ];
        envType = 'single tenant';
      }
    }

    const resourceType = this.lmUrlUtilService.getResourceTypeFromUrl(req.url);

    if (resourceType === undefined // /bpm/ionInboxLoad call from mingle drillback
      || resourceType === AppConstants.RESOURCETYPE_APPS     // Dont gather info for app call
      || resourceType === AppConstants.RESOURCETYPE_FACADE
      || resourceType === AppConstants.RESOURCETYPE_BUILDER
      || (resourceType === AppConstants.RESOURCETYPE_BANNER     // Dont gather info for telegref or unreacount calls
        && (processUrl.indexOf('telegraf') >= 0 || processUrl.indexOf('unreadCount') >= 0 || processUrl.indexOf('localeData') >= 0))) {
      return next.handle(req);
    }

    let configFlag = true;

    // Log menu info
    if (resourceType === AppConstants.RESOURCETYPE_BANNER && processUrl.indexOf('requestType=') === -1) {
      configFlag = false;
      this.componentInfo = {
        name: resourceType,
        componentType: undefined,
        userWebRequestId: comp ? comp.getUserWebRequestId() : undefined,
        type: resourceType,
        displayType: this.componentInfo?.displayType,
        status: new Array<string>(),
        configInfo: hasCompConfigInfo ? compConfigInfo : undefined,
        developer: context ? this.lmContextService.isDeveloper() : undefined,
        tenant,
        envType,
        module: hasCompInfo ? this.componentInfo?.module : undefined,
        message: hasCompInfo ? this.componentInfo?.message : undefined,
        hasConfigAccess: this.lmContextService.hasConfigAccess(),
        theme: this.lmThemeService.getCurrentThemeId(),
        color: this.lmThemeService.getCurrentColorId(),
        menuVersion: this.lmContextService.getContext().uiMenuVersion
      };
    } else
    // we will construct a simple componentInfo if the url is home or menu because the currently loaded component does not apply to this call.
    if (resourceType === AppConstants.RESOURCETYPE_HOME  || resourceType === AppConstants.RESOURCETYPE_MENU) {
      const userWebRequestId = hasCompInfo ? comp.getUserWebRequestId() : undefined;
      const displayType = hasCompInfo ? this.componentInfo?.displayType : undefined;
      const module = hasCompInfo ? this.componentInfo?.module : undefined;
      const message = hasCompInfo ? this.componentInfo?.message : undefined;

      this.componentInfo = {
        name: resourceType,
        componentType: undefined,
        type: resourceType,
        userWebRequestId,
        displayType,
        status: new Array<string>(),
        configInfo: hasCompConfigInfo ? compConfigInfo : undefined,
        developer: context ? this.lmContextService.isDeveloper() : undefined,
        tenant,
        envType,
        module,
        message,
        hasConfigAccess: this.lmContextService.hasConfigAccess(),
      };
    } else {
      const lmBaseUrlInfo: LMBaseUrlInfo = this.lmUrlInfoBuilderService.getBaseUrlInfoFromHttpUrl(req.url);
      // const displayType = this.componentInfo?.displayType || undefined;
      // const module = this.componentInfo?.module || undefined;
      // const message = this.componentInfo?.message || undefined;

      let fromListResourceId: string | undefined;
      let sourceResourceId: string | undefined;

      if (lmBaseUrlInfo.fromListResource?.generateResourceId) {
        fromListResourceId = lmBaseUrlInfo.fromListResource.generateResourceId(false);
      }
      if (lmBaseUrlInfo.sourceResource?.generateResourceId) {
        sourceResourceId = lmBaseUrlInfo.sourceResource.generateResourceId(false);
      }

      this.componentInfo = {
        componentType: undefined,
        userWebRequestId: hasCompInfo && comp.getUserWebRequestId().length > 0 ? comp.getUserWebRequestId() : encodeURI(Soho.Locale.translate('NoRouteComp')),
        name: lmBaseUrlInfo?.resource?.uiResourceName,
        formName: lmBaseUrlInfo?.resource?.uiResourceName,
        busClassName: lmBaseUrlInfo?.resource?.busClassName,
        type: lmBaseUrlInfo?.resource?.resourceType,
        displayType: this.componentInfo?.displayType,
        status: new Array<string>(),
        configInfo: hasCompConfigInfo ? compConfigInfo : undefined,
        fromListResourceId,
        panelNavigation: hasCompInfo ? this.componentInfo?.panelNavigation : undefined,
        developer: context ? this.lmContextService.isDeveloper() : undefined,
        sourceResourceType: lmBaseUrlInfo.sourceResource ? lmBaseUrlInfo.sourceResource.resourceType : undefined,
        sourceResourceId,
        tenant,
        envType,
        module: this.componentInfo?.module,
        message: this.componentInfo?.message,
        hasConfigAccess: this.lmContextService.hasConfigAccess(),
      };
    }
    const requestInfo = this.lmGlobalUtilService.getUrlRequestInfoJson(this.componentInfo as LMComponentInfo, -1, configFlag, false);
    const standardRequestFormatInfo = this.formatJsonForOutput(requestInfo);
    const requestInfoJson = JSON.stringify(standardRequestFormatInfo);
    webReportHeaders = webReportHeaders.append('UserWebRequest', requestInfoJson);

    const clonedRequest = req.clone({ headers: webReportHeaders });
    return next.handle(clonedRequest);

    return next.handle(req);
  }

  private formatJsonForOutput(telegrafProperties: TelegrafProperties) {

    const output = {
      Actor: telegrafProperties.actorUniqueId,
      BusinessClass: telegrafProperties.businessClass,
      BusViewName: telegrafProperties.uiView,
  //    AccountId: telegrafProperties.accountId,
      WebApp: telegrafProperties.webApp,
      UserWebRequestId: telegrafProperties.userWebRequestId,
  //    Product: telegrafProperties.application ? telegrafProperties.application.toLowerCase() : undefined,
  //    TenantTypeConfig: telegrafProperties.environmentType ? telegrafProperties.environmentType.toLowerCase() : undefined,
      URLParams: telegrafProperties.urlParams,
      UserAgent: telegrafProperties.userAgent,
      URL: telegrafProperties.url,
      BusViewType: telegrafProperties.uiViewType,
      //   clientIp: ,
      ISOLocale: telegrafProperties.isoLocale,
      DisplayType: telegrafProperties.displayType,
      IsConfiguration: telegrafProperties.isConfigured,
      IsPersonalization: telegrafProperties.isPersonalized,
      UserFolder: telegrafProperties.userFolder,
      TenantName: telegrafProperties.tenant ? telegrafProperties.tenant.toLowerCase() : undefined,
      TenantType: telegrafProperties.envType ? telegrafProperties.envType.toLowerCase() : undefined,
      Module: telegrafProperties.module,
      Message: telegrafProperties.message,
      isReport: telegrafProperties.isReport || telegrafProperties.userFolder,
      theme: telegrafProperties.theme,
      color: telegrafProperties.color,
      menuVersion: telegrafProperties.menuVersion
    };

    return output;
  }

  private setMingleActivateCookie(req: HttpRequest<any>) {
    if (this.lmContextService.inMingle()) {
      // Is this a notification poll request? Do not update the cookie on poll requests.
      // This is similar to session timeout logic in LBaseAction.
      const isPoll = req.method.toLowerCase() === 'get' && (req.urlWithParams.indexOf('banner') > -1) && (req.urlWithParams.indexOf('requestType=unreadCount') > -1);
      if(!isPoll) {
        // LMWEB-2494: Update Mingle activity cookie (for users that are just browsing)
        // LMRK-102637: cookie also updated in app.component (recruiter taking notes during interview, no new requests)
        this.lmContextService.setMingleActivityCookie();
      }
    }
  }
}
